export const defaultScannerHeight = '50vh'
export const mobileScannerMaxHeight = '50dvh'
export const mobileActionPadding = 'calc(env(safe-area-inset-bottom, 0px) + 16px)'

export function getAddMyRelationLayout(isSmallDevice: boolean) {
  return {
    scannerHeight: defaultScannerHeight,
    scannerMaxHeight: isSmallDevice ? mobileScannerMaxHeight : undefined,
    formStyle: isSmallDevice ? { paddingBottom: mobileActionPadding } : undefined,
  }
}
